import { some } from 'lodash';


export class BaseService {
  public BaseURL: string;


    constructor() {

    }

    URLEncode(data: any): string {
        if (data == undefined || data == null)
            return "";

        return encodeURIComponent(data);
    }

    FindError(rows, errString: string) {
        rows = rows || [];
        return some(rows, row => row.ErrorMessage === errString);
    }
}
